import { motion } from "framer-motion";

export const Hero = () => {
  return (
    <section
      id="inicio"
      data-testid="hero-section"
      className="relative bg-[#17351D] text-white min-h-screen flex flex-col overflow-hidden grain"
    >
      {/* Side label */}
      <div className="hidden md:flex absolute left-6 top-1/2 -translate-y-1/2 -rotate-90 origin-left items-center gap-3 text-[10px] tracking-[0.5em] uppercase text-white/40">
        <span className="h-px w-12 bg-white/40" />
        Zapopan · Jalisco · México
      </div>

      <div className="hidden md:flex absolute right-6 top-1/2 -translate-y-1/2 rotate-90 origin-right items-center gap-3 text-[10px] tracking-[0.5em] uppercase text-white/40">
        Auditoría · Contabilidad · Legal
        <span className="h-px w-12 bg-white/40" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex-1 flex items-center pt-28 pb-16">
        <div className="max-w-[1440px] w-full mx-auto px-6 md:px-12">
          <div className="max-w-5xl">
            <h1 className="font-display font-medium leading-[0.95] tracking-tight text-white">
              <motion.span
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, ease: [0.22, 1, 0.36, 1], delay: 0.1 }}
                className="block text-[clamp(2.6rem,8vw,7rem)]"
              >
                Lex Balance
              </motion.span>
              <motion.span
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, ease: [0.22, 1, 0.36, 1], delay: 0.25 }}
                className="block text-[clamp(2.6rem,8vw,7rem)] italic text-[#C1C82A]"
              >
                Perfecto<span className="text-white not-italic">.</span>
              </motion.span>
            </h1>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.45 }}
              className="mt-10 max-w-2xl text-base md:text-lg text-white/70 leading-relaxed font-body"
            >
              Una organización financiera consolidada en auditorías a despachos y
              clientes particulares. Excelencia, confidencialidad y precisión en
              cada servicio que ofrecemos.
            </motion.p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
